import { ReactNode } from "react";
import luxuryArizonaHome from "@/assets/luxury-arizona-home-bg-optimized.jpg";
import arizonaBiltmore from "@/assets/arizona-biltmore-bg.jpg";

interface PageBackgroundProps {
  children: ReactNode;
  className?: string;
  variant?: "residential" | "commercial";
}

export function PageBackground({ children, className = "", variant = "residential" }: PageBackgroundProps) {
  const backgroundImage = variant === "commercial" ? arizonaBiltmore : luxuryArizonaHome;
  const backgroundAlt =
    variant === "commercial"
      ? "Arizona commercial property with tile flooring maintained by Lazona Tile Care"
      : "Luxury Arizona home interior with restored tile, grout and natural stone surfaces";
  
  return (
    <div className={`min-h-screen bg-background relative ${className}`}>
      {/* Dynamic backdrop based on variant - using <img> for LCP compatibility */}
        <div className="fixed inset-0 z-0">
        <img
          src={backgroundImage}
          alt={backgroundAlt}
          width={1344}
          height={764}
          loading="lazy"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
        {/* Lighter overlay for more realistic photo visibility */}
        <div className="absolute inset-0 bg-background/75" />
        {/* Subtle teal accent glows - inside fixed container to prevent CLS */}
        <div className="absolute top-1/4 -left-20 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute top-3/4 -right-20 w-80 h-80 bg-primary/4 rounded-full blur-3xl" />
      </div>
      {/* Page content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
}
